import clsx from 'clsx';
import React from 'react';

import HighlightSearchTerm from '@/src/components/project/Common/Typography/HighlightSearchTerm';
import { getValueWithEllipsis } from '@/src/util/strings';

const FIRST_CHARACTERSLENGTH = 20;
const lastCharactersLength = 20;
const MAX_LENGTH = 50;

type EmailSendersProps = {
  senders: string[];
};

export const getSendersLabel = (
  senders: string[],
  maxLength = MAX_LENGTH,
  firstCharactersLength = FIRST_CHARACTERSLENGTH
) => {
  const sendersString = senders.join(', ');

  if (sendersString.length <= maxLength) {
    return sendersString;
  }
  const firstCharacters = sendersString.substring(0, firstCharactersLength);
  const lastSender = senders[senders.length - 1];

  // If senders hidden count is needed:
  // const firstCharactersUserCount = firstCharacters.split(',').length;
  // const hiddenSendersCount = senders.length - firstCharactersUserCount;
  // const sendersCountLabel = hiddenSendersCount > 0 ? hiddenSendersCount : null;

  return firstCharacters + '..., ' + getValueWithEllipsis(lastSender, lastCharactersLength);
};

const EmailSenders = ({ senders }: EmailSendersProps) => {
  const sendersLabel = getSendersLabel(senders);

  return (
    <p className={clsx('tw-text-[12px] tw-text-cfo-black', 'tw-m-0', 'tw-font-brandonTextMedium')}>
      <HighlightSearchTerm>{sendersLabel}</HighlightSearchTerm>
    </p>
  );
};

export default EmailSenders;
